<script>
import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import api from '@/odooapi'
import rpc from '@/odoorpc'
import or from 'vuelidate/lib/validators/or'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '销售订单',
    meta: [{
      name: 'description',
      content: appConfig.description
    }],
  },
  components: {
    Layout,
  },

  data() {
    return {
      // 查询参数
      queryParams: {
        roleName: undefined,
        roleKey: undefined,
        status: undefined
      },
      // 显示搜索条件
      showSearch: true,

      maxHeight: '328px',
      // 日期范围
      dateRange: [],
      // 数据列表
      salesList: [],
      //
      allDate: [],

      paginationData: {   // 分页信息
        // 总数据条数
        total:0,
        // 当前页
        currentPage:1,
        // 每页展示几条数据
        page_Size:10,
      },

      infoPageData:{
        total:0,
        currentPage:1,
        page_Size:10,
      },
      orderId:'',

      // 查询参数
      // queryParams: {
      //   pageNum: 0,
      //   pageSize: 10,
      // },
      // domain: [],
      // fields: ['partner_id', 'order_id', 'client_order_ref', 'order_type', 'product_cat',
      //   'product_tmpl_id', 'production_qty'
      // ],
      // order: 'id DESC',
      state: '',
      options: [{
        value: '选项1',
        label: '新建'
      }, {
        value: '选项2',
        label: '报价'
      }, {
        value: '选项3',
        label: '评审'
      }, {
        value: '选项4',
        label: '确认'
      }, {
        value: '选项5',
        label: '执行'
      }],
      value: '',
      dialogVisible:false,
      dialogOrderInfo:false,
      // 订单详情
      tableDataInfo: {},
      // 物料核料明细
      tableDataDetails:[],
      jdcxDialog:false,
      outGoingData:[],
      isExpand:true,
      order_info:{},
      order_routing:[],
      plan_routing:[]

    }
  },
  created() {
    // this.getList()
    this.getData()
  },
  methods: {
    // 查看状态及发货记录
    production_schedule(sop_id){
      this.jdcxDialog=true

      rpc.web.dataset.call_kw({
        model:'mrp.production',
        method:'search_production_schedule',
					args:[],
					kwargs:{
						"sop_id":sop_id
					}
      })
      .then(res=>{
          if(res.code=='ok'){
								this.order_info=res.order_info
								this.order_routing=res.order_routing
								this.plan_routing=res.plan_routing
          }
      })
      this.clickoutgoing(sop_id)
      
    },

    // 发货记录
    clickoutgoing(sop_id){

      rpc.web.dataset.call_kw({
        model:'sale.order',
        method:'search_outgoing',
				args:[],
				kwargs:{
						"sop_id":sop_id
					}
      })
      .then(res=>{
          if(res.code=='ok'){
            this.outGoingData=res.data

            // this.outGoingData.forEach((data) => {
            //   data.routes.forEach((route) => {
            //     route.routes.sort(
            //       (a, b) => new Date(b.acceptTime) - new Date(a.acceptTime)
            //     );
            //     // 标记最新的acceptTime对象的color为某个值
            //     route.routes[0].color = "blank";
            //   });
            // });

          }
      })

      // rpc.web.dataset.json_call('/search/outgoing',{
      //   sop_id:sop_id,
      // })
      // .then(res=>{
      //   if(res.code=="ok"){
      //     this.outGoingData=res.data
          

      //     this.outGoingData.forEach((data) => {
      //       data.routes.forEach((route) => {
      //         route.routes.sort(
      //           (a, b) => new Date(b.acceptTime) - new Date(a.acceptTime)
      //         );
      //         // 标记最新的acceptTime对象的color为某个值
      //         route.routes[0].color = "blank";
      //       });
      //     });

          

      //   }
      // })

    },

    // 订单详情
    sop_info(sop_id){
      rpc.web.dataset.call_kw({
        model: 'sale.order.productions',
        method: 'search_sale_order_productions_info',
        args: [],
        kwargs: {
          "sop_id": sop_id
          // "currentPage":this.infoPageData.currentPage,
          // "pageSize":this.infoPageData.page_Size,
        }
      })
      .then(res=>{
        this.tableDataInfo = res.info
        this.dialogOrderInfo = true

      })
    },
    
    // 查询核料明细
    info(order_id){
      this.orderId = order_id
      this.dialogVisible = true

      rpc.web.dataset.call_kw({
        model:'sale.order.productions',
        method:'search_sale_order_productions_bom_info',
        args:[],
        kwargs:{
          "order_id":order_id,
          "currentPage":this.infoPageData.currentPage,
          "pageSize":this.infoPageData.page_Size,
        }
      })
      .then(res=>{
        this.tableDataDetails = res.data
        this.infoPageData.total = res.total
      })

    },
    // 物料核料明细分页
    infoPageSize(page_size){
      this.infoPageData.page_Size = page_size
      this.info(this.orderId)

    },
    infoPageChange(pageNum){
      this.infoPageData.currentPage=pageNum
      this.info(this.orderId)
    },
    // 关闭对话框
    infoClose(){
      this.dialogVisible = false
      this.infoPageData.currentPage = 1
    },

    /** 搜索按钮操作 */
    handleQuery() {
      if(!this.queryParams.roleName || !this.queryParams.roleKey){
        this.paginationData.currentPage = 1
        
      }
      this.getData()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.roleName = ""
      this.queryParams.roleKey = ""
      this.paginationData.currentPage = 1
      this.getData()
    },
    // 分页
    handlePageSize(page_size){
      this.paginationData.page_Size=page_size
      // 这里写获取的的方法
      this.getData()

    },
    handlePageChange(pageNum){
      this.paginationData.currentPage=pageNum
      // 这里写获取的的方法
      this.getData()
    },
    getData(){
      rpc.web.dataset.call_kw({
        model: 'sale.order.productions',
        method: 'search_sale_order_productions',
        args: [],
        kwargs: {
          "currentPage":this.paginationData.currentPage,
          "pageSize":this.paginationData.page_Size,
          "client_order_ref":this.queryParams.roleName,
          "product_tmpl_name":this.queryParams.roleKey
        }
      })
      .then(res=>{
        this.salesList = res.data
        this.paginationData.total = res.total
        
      })
      .catch(err=>{

      })
    },

    // handleSizeChange(val) {
    //   this.paginationData.pageSize = val
    //   this.getList()
    // },
    // handleCurrentChange(val) {
    //   this.paginationData.pageIndex = val
    //   this.getList()
    // },

    // getList() {
    //   this.queryParams.pageNum = 0;
    //   // const Model = api.env.model('sale.order.productions')
    //   rpc.web.dataset.call_kw({
    //     model: 'sale.order.productions',
    //     method: 'search_sale_order_productions',
    //     args: [],
    //     kwargs: {}
    //   }).then(res => {
    //     this.allData = res
    //     this.salesList = this.allData.slice((this.paginationData.pageIndex - 1) * this.paginationData.pageSize, this.paginationData.pageIndex * this.paginationData.pageSize)
    //     this.paginationData.total = this.allData.length
    //     this.tableData.forEach((el, i) => {
    //       el.$index = (this.paginationData.pageIndex - 1) * this.paginationData.pageSize + 1 + i;
    //     });
    //   })
    // },
  }
}
</script>

<template>
  <Layout>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">订单中心</h4>
      </div>
      <!--      <div class="col-sm-4 col-xl-6 text-sm-right">-->
      <!--        <div class="btn-group ml-2 d-none d-sm-inline-block">-->
      <!--          <button type="button" class="btn btn-soft-primary btn-sm">-->
      <!--            <i class="uil uil-edit mr-1"></i>创建-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body p-0">
            <el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true" class="p-3">
              <el-form-item label="客户订单编号" prop="roleName">
                <el-input v-model="queryParams.roleName" placeholder="请输入客户订单编号" clearable size="small"
                          style="width: 240px" @keyup.enter.native="handleQuery"/>
              </el-form-item>
              <el-form-item label="规格型号" prop="roleKey">
                <el-input v-model="queryParams.roleKey" placeholder="请输入规格型号" clearable size="small"
                          style="width: 240px" @keyup.enter.native="handleQuery"/>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
                </el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
              </el-form-item>
            </el-form>
            <div style="margin-top: -0.6rem;">
              <el-table :data="salesList" style="width: 100%" class="p-3">
                <el-table-column type="selection" width="55" align="center"/>
                <!-- <el-table-column prop="partner_name" label="客户"/> -->
                <el-table-column prop="order_name" label="订单编号"/>
                <el-table-column prop="client_order_ref" label="客户订单编号"/>
                <el-table-column prop="order_type" label="订单类型"/>
                <el-table-column prop="product_cat" label="订单名称"/>
                <el-table-column prop="product_tmpl_name" label="规格型号"/>
                <el-table-column prop="production_qty" label="订单数量"/>
                <el-table-column prop="delivery_qty" label="已交付数量"/>
                <!-- <el-table-column prop="current_task_state" label="当前状态"/> -->

                <el-table-column label="查看明细">
                  <template slot-scope="scope">
                    <div><el-button type="text" size="medium" @click="sop_info(scope.row.order_id)">订单详情</el-button></div>
                    <div><el-button type="text" size="medium" @click="info(scope.row.order_id)" v-show="scope.row.is_show_info">核料详情</el-button></div>
                    <div><el-button type="text" size="medium" @click="production_schedule(scope.row.order_id)">查看状态</el-button></div>
                  </template>
                </el-table-column>

              </el-table>
            </div>

            <el-dialog
                  :visible.sync="dialogVisible"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                  :show-close="false"
                  title="物料核料明细"
                  width="80%"
              >
                <el-table
                    :data="tableDataDetails"
                    style="width: 100%">
                  <el-table-column
                      prop="bom_line_name"
                      label="物料名称">
                  </el-table-column>
                  <el-table-column
                      prop="bom_line_model"
                      label="物料类型">
                  </el-table-column>
                  <el-table-column
                      prop="bom_line_product_qty"
                      label="需求数量">
                  </el-table-column>
                  <el-table-column
                      prop="bom_line_incoming"
                      label="来料数量">
                  </el-table-column>
                </el-table>


                <span slot="footer" class="dialog-footer">
                  <el-button type="danger" @click="infoClose">关闭</el-button>
                </span>
                
                <el-pagination
                  background
                  style="margin-top: 20px; text-align: right;"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="infoPageData.total"
                  :current-page="infoPageData.currentPage"
                  :page-size="infoPageData.page_Size"
                  :page-sizes="[10, 30, 50]"
                  @size-change="infoPageSize"
                  @current-change="infoPageChange"
                >
                </el-pagination>

                
              </el-dialog>


              <el-dialog title="进度查询" :append-to-body="true"  :visible.sync="jdcxDialog" width="55%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
                <div style="margin-bottom: 25px" v-if="outGoingData.length > 0">
                  <div class="v-form-title" style="margin:0 0 20px 0;" >发货记录</div>
                    <el-table :data="outGoingData" border :default-expand-all="isExpand">
                      <el-table-column label="序号" type="index" width="60px" ></el-table-column>
                      <el-table-column property="product_id" label="规格型号" align="center">
                      </el-table-column>
                      <el-table-column property="picking_id" label="出库单号" align="center">
                      </el-table-column>
                      <!-- <el-table-column property="partner_address" label="客户地址" align="center">
                      </el-table-column> -->
                      <el-table-column property="quantity_done" label="发货数量" align="center" width="97">
                      </el-table-column>
                      <el-table-column property="delivery_type" label="配送方式" align="center" width="97">
                      </el-table-column>
                      <el-table-column property="express_no" label="快递单号" align="center">
                      </el-table-column>
                      <el-table-column property="date" label="发货日期" align="center" width="117">
                      </el-table-column>


                    <!-- <el-table-column type="expand" width="1">
                      <template slot-scope="props" v-if="props.row.express_no !== '无'">
                        <el-collapse>
                          <el-collapse-item name="1">
                            <template slot="title">
                              <div class="order_module" style="width: 100%;color: #606266;">快递进度</div>
                            </template>
                            <el-timeline style="margin-left:10px">
                              <el-timeline-item
                                v-for="(route, index) in props.row.routes[0].routes"
                                :key="index"
                              color="green"
                                >
                              <div v-if="route.color"><span style="color:blank;margin-right:20px;">{{route.acceptTime}}</span><span>{{route.remark}}</span></div>
                              <div v-else><span style="color:#909399;margin-right:20px;">{{route.acceptTime}}</span><span style="color:#909399;">{{route.remark}}</span></div>
                              </el-timeline-item>
                            </el-timeline>
                          </el-collapse-item>
                        </el-collapse>
                      </template>
                    </el-table-column> -->
                  </el-table>
                <!-- <br><br> -->
                </div>





                  <!-- <div>
                    <div class="v-form-title" style="margin:0 0 20px 0;" >SMT订单信息</div>
                      <div style="margin-left: 20px;">
                        <el-row :gutter="20" style="margin-bottom: 20px;">
                          <el-col :span="6"><div class="grid-content bg-purple">客户编号：<span style="font-weight:600;">{{ order_info.partner_ref==false ? "" : order_info.partner_ref}}</span></div></el-col>
                          <el-col :span="18"><div class="grid-content bg-purple">规格型号：<span style="font-weight:600;">{{order_info.product_tmpl_name}}</span></div></el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="6"><div class="grid-content bg-purple">订单数量：<span style="font-weight:600;">{{order_info.production_qty}}</span></div></el-col>
                          <el-col :span="18"><div class="grid-content bg-purple">预计最快发货日期：<span style="font-weight:600;">{{order_info.delivery_time}}</span></div></el-col>
                        </el-row>
                      </div>
                  </div> -->
      
                  <div>
                    <div class="v-form-title" style="margin:20px 0 20px 0;" >生产进度</div>
                      <div style="margin-left: 20px">
              
                        <div class="order_module" style="margin-bottom: 20px;">生产准备</div>
                        <div style="margin-bottom: 20px;position: relative;">
                          <div>订单编号：<span style="font-weight:600;">{{order_info.order_name}}</span></div>

                        </div>
                        <el-timeline>
                          <el-timeline-item
                            v-for="(order, index) in order_routing"
                            :key="index"
                            :color="order.color"
                            :timestamp="order.plan_date_done">
                            {{order.name}}
                          </el-timeline-item>
                        </el-timeline>


                

                <!-- 生产进度（不折叠版） -->
                        <div class="order_module" style="margin-bottom: 20px;">生产进度</div>
                        <el-timeline>
                          <div style="display: flex; flex-wrap: nowrap;">
                            <div v-for="(plans, index) in plan_routing" style="margin: 20px 30px 0 0;" :key="index">
                              <el-timeline-item
                                v-for="(plan, idx) in plans"
                                  :key="idx"
                                  :color="plan.color"
                                  :timestamp="plan.plan_date_done">
                                  {{plan.name}}
                              </el-timeline-item>
                            </div>
                          </div>
                


                        </el-timeline>
                      </div>
            
                    </div>
                  <!-- </div> -->
							
							</el-dialog>



              <el-dialog title="订单详情" :append-to-body="true"  :visible.sync="dialogOrderInfo" width="55%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">

                <div class="v-form-title" style="margin:20px 0 20px 0;" >物料信息</div>
                <el-descriptions class="margin-top" v-bind="{column:3}" border="border"
																		style="margin-top: 20px;">
														<el-descriptions-item>
															<template slot="label">
																物料种类总数
															</template>
															{{tableDataInfo.product_type_qty}}
														</el-descriptions-item>
														<el-descriptions-item>
															<template slot="label">
																物料管理要求
															</template>
															{{tableDataInfo.material_type}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																物料来源
															</template>
															{{tableDataInfo.bom_source}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																物料种类(解析)
															</template>
															{{tableDataInfo.bom_cat_qty}}
														</el-descriptions-item>
														<el-descriptions-item>
															<template slot="label">
																表贴物料种类(解析)
															</template>
															{{tableDataInfo.smt_cat_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																直插物料种类(解析)
															</template>
															{{tableDataInfo.dip_cat_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																来料检验
															</template>
															{{tableDataInfo.hl_check_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																表贴物料个数(解析)
															</template>
															{{tableDataInfo.smt_product_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																直插物料个数(解析)
															</template>
															{{tableDataInfo.dip_product_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																bga数量(解析)
															</template>
															{{tableDataInfo.bga_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																表贴焊点数(解析)
															</template>
															{{tableDataInfo.smt_welds_qty}}
														</el-descriptions-item>
                            <el-descriptions-item>
															<template slot="label">
																直插焊点数(解析)
															</template>
															{{tableDataInfo.dip_welds_qty}}
														</el-descriptions-item>
								</el-descriptions>

                <div class="v-form-title" style="margin:20px 0 20px 0;" >板子尺寸</div>
                <el-descriptions class="margin-top" v-bind="{column:2}" border="border"
																		style="margin-top: 20px;">
														<el-descriptions-item>
															<template slot="label">
																单板长度
															</template>
															{{tableDataInfo.pcb_l}}
														</el-descriptions-item>
														<el-descriptions-item>
															<template slot="label">
																单板宽度
															</template>
															{{tableDataInfo.pcb_w}}
														</el-descriptions-item>
								</el-descriptions>
							
							</el-dialog>

            


            <el-pagination
                background
                style="margin-top: 20px; text-align: right;"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paginationData.total"
                :current-page="paginationData.currentPage"
                :page-size="paginationData.page_Size"
                :page-sizes="[10, 30, 50]"
                @size-change="handlePageSize"
                @current-change="handlePageChange"
                >
            </el-pagination>
            
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style>
.el-table th.el-table__cell {
  background-color: #f8f8f9;
}

.el-form-item {
  margin-bottom: -0.5rem;
}

.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
  border-bottom: 1px solid #dfe6ec;
}

.el-table .el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  margin-left: 5px;
}
.v-form-title{
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0 0 0;
    background: #ecf8ff;
    padding: 7px 0 7px 7px;
}
.v-form-title:before {
    content: " ";
    padding-right: 5px;
    height: 10px;
    border-left: 5px solid #50bfff;
}
.order_module{
	line-height: 32px;
    background-color:#eee;
    padding: 0 10px;
    font-size: 18px;
    font-weight: 700 !important;
}
</style>
